import { Row, Form } from "antd";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Title from "src/components/common/Title";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import { useContext } from "src/ReactTS";
import { FormComponentProps } from "antd/lib/form";
import { IVendaProps } from "src/services/interfaces/IVendaProps";
import { ServiceContext } from "src/services/provider/Service.provider";

import "./payment-confirmation.scss";

function PaymentConfirmation(props: RouteComponentProps<any> & FormComponentProps & IVendaProps) {
  const { documentService } = useContext(ServiceContext);
  const { trade } = props;
  const [loading, setLoading] = React.useState(false);

  return (
    <div className="payment-confirmation steps-container">
      <h1>PAGAMENTO EFETUADO</h1>
      {trade && (
        <Title size="h4" style={{ color: "#211947", marginBottom: "65px" }}>
          <br />
          Pagamento efetuado com sucesso
          <br />
          Valor : {MoneyMask(trade.tradePricing.pricing.price)} <br />
          Favorecido : {trade.tradeOwner.fullName}
          <br />
          Banco : {trade.tradeOwner.bankData.bank}
          <br />
          Agencia : {trade.tradeOwner.bankData.agency}
          <br />
          Conta : {trade.tradeOwner.bankData.accountDigit ? `${trade.tradeOwner.bankData.account}-${trade.tradeOwner.bankData.accountDigit}` : trade.tradeOwner.bankData.account}
          <br />
          Tipo Conta : {trade.tradeOwner.bankData.accountType}
          <br />
          Data Pagamento :{" "}
          {trade.tradePricing.pricing.disbursementDate.toDate()
            .toLocaleString("pt-BR")
            .split("T")[0]
            .split("-")
            .reverse()
            .join("/")}
        </Title>
      )}

      <Row className="actions-btn-row" type="flex" align="middle" justify="center" style={{ textAlign: "center" }}>
        <StandardButton
          style={{ maxWidth: "324px" }}
          loading={loading}
          onClick={() => {
            setLoading(true);
            documentService.downloadContractByTradeId(trade.id).finally(() => setLoading(false));
          }}
        >
          {loading ? "Aguarde..." : "Baixar Contrato"}
        </StandardButton>
      </Row>
    </div>
  );
}

export default withRouter(Form.create()(PaymentConfirmation));



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/payment/PaymentConfirmation.tsx